import type { Bootstrap, Category, Kind, PaymentMethod } from '../api/types';

/** 새 입력 선택지는 활성 항목만, 과거 조회 필터는 보관된 항목까지 보여준다(설계서 4장). */
export function topCategories(b: Bootstrap, kind?: Kind, includeArchived = false): Category[] {
  return b.categories.filter((c) => c.parentId === null && (!kind || c.kind === kind) && (includeArchived || c.active));
}

export function childCategories(b: Bootstrap, parentId: string | null | undefined, includeArchived = false): Category[] {
  if (!parentId) return [];
  return b.categories.filter((c) => c.parentId === parentId && (includeArchived || c.active));
}

export function paymentMethods(b: Bootstrap, kind?: Kind, includeArchived = false): PaymentMethod[] {
  return b.paymentMethods.filter((p) => (!kind || p.kind === kind) && (includeArchived || p.active));
}

export const categoryName = (b: Bootstrap, id: string | null | undefined) => (id ? (b.categories.find((c) => c.id === id)?.name ?? '알 수 없음') : '');

/** 선택 목록: 활성 항목 + (수정 중인 기록이 이미 쓰고 있는) 보관 항목 하나. */
export function withCurrent<T extends { id: string; active: boolean }>(active: T[], all: T[], currentId: string | null | undefined): T[] {
  if (!currentId || active.some((x) => x.id === currentId)) return active;
  const current = all.find((x) => x.id === currentId);
  return current ? [...active, current] : active;
}
